@file:OptIn(InternalResourceApi::class)

package gero.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/gero.composeapp.generated.resources/"

@delegate:ResourceContentHash(1_546_931_802)
internal val Res.drawable.F1A: DrawableResource by lazy {
      DrawableResource("drawable:F1A", setOf(
        ResourceItem(setOf(), "${MD}drawable/F1A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-995_049_256)
internal val Res.drawable.F2: DrawableResource by lazy {
      DrawableResource("drawable:F2", setOf(
        ResourceItem(setOf(), "${MD}drawable/F2.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_099_387_769)
internal val Res.drawable.F20: DrawableResource by lazy {
      DrawableResource("drawable:F20", setOf(
        ResourceItem(setOf(), "${MD}drawable/F20.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_887_309_371)
internal val Res.drawable.F21: DrawableResource by lazy {
      DrawableResource("drawable:F21", setOf(
        ResourceItem(setOf(), "${MD}drawable/F21.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_391_029_219)
internal val Res.drawable.F21A: DrawableResource by lazy {
      DrawableResource("drawable:F21A", setOf(
        ResourceItem(setOf(), "${MD}drawable/F21A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-735_956_115)
internal val Res.drawable.F22: DrawableResource by lazy {
      DrawableResource("drawable:F22", setOf(
        ResourceItem(setOf(), "${MD}drawable/F22.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(572_444_455)
internal val Res.drawable.F23: DrawableResource by lazy {
      DrawableResource("drawable:F23", setOf(
        ResourceItem(setOf(), "${MD}drawable/F23.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_900_560_347)
internal val Res.drawable.F24: DrawableResource by lazy {
      DrawableResource("drawable:F24", setOf(
        ResourceItem(setOf(), "${MD}drawable/F24.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(976_869_420)
internal val Res.drawable.F25: DrawableResource by lazy {
      DrawableResource("drawable:F25", setOf(
        ResourceItem(setOf(), "${MD}drawable/F25.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_895_464_356)
internal val Res.drawable.F26: DrawableResource by lazy {
      DrawableResource("drawable:F26", setOf(
        ResourceItem(setOf(), "${MD}drawable/F26.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-758_492_485)
internal val Res.drawable.F27: DrawableResource by lazy {
      DrawableResource("drawable:F27", setOf(
        ResourceItem(setOf(), "${MD}drawable/F27.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_440_271_619)
internal val Res.drawable.F28: DrawableResource by lazy {
      DrawableResource("drawable:F28", setOf(
        ResourceItem(setOf(), "${MD}drawable/F28.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_004_327_321)
internal val Res.drawable.F29: DrawableResource by lazy {
      DrawableResource("drawable:F29", setOf(
        ResourceItem(setOf(), "${MD}drawable/F29.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_943_280_356)
internal val Res.drawable.F3: DrawableResource by lazy {
      DrawableResource("drawable:F3", setOf(
        ResourceItem(setOf(), "${MD}drawable/F3.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_181_951_828)
internal val Res.drawable.F30: DrawableResource by lazy {
      DrawableResource("drawable:F30", setOf(
        ResourceItem(setOf(), "${MD}drawable/F30.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-810_758_776)
internal val Res.drawable.F31: DrawableResource by lazy {
      DrawableResource("drawable:F31", setOf(
        ResourceItem(setOf(), "${MD}drawable/F31.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_927_540_338)
internal val Res.drawable.F31A: DrawableResource by lazy {
      DrawableResource("drawable:F31A", setOf(
        ResourceItem(setOf(), "${MD}drawable/F31A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-505_793_520)
internal val Res.drawable.F32: DrawableResource by lazy {
      DrawableResource("drawable:F32", setOf(
        ResourceItem(setOf(), "${MD}drawable/F32.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(241_691_556)
internal val Res.drawable.F33: DrawableResource by lazy {
      DrawableResource("drawable:F33", setOf(
        ResourceItem(setOf(), "${MD}drawable/F33.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(379_951_863)
internal val Res.drawable.F34: DrawableResource by lazy {
      DrawableResource("drawable:F34", setOf(
        ResourceItem(setOf(), "${MD}drawable/F34.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-862_627_276)
internal val Res.drawable.F35: DrawableResource by lazy {
      DrawableResource("drawable:F35", setOf(
        ResourceItem(setOf(), "${MD}drawable/F35.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-987_680_341)
internal val Res.drawable.F36: DrawableResource by lazy {
      DrawableResource("drawable:F36", setOf(
        ResourceItem(setOf(), "${MD}drawable/F36.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_100_213_303)
internal val Res.drawable.F37: DrawableResource by lazy {
      DrawableResource("drawable:F37", setOf(
        ResourceItem(setOf(), "${MD}drawable/F37.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_890_418_694)
internal val Res.drawable.F37A: DrawableResource by lazy {
      DrawableResource("drawable:F37A", setOf(
        ResourceItem(setOf(), "${MD}drawable/F37A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_095_459_488)
internal val Res.drawable.F38: DrawableResource by lazy {
      DrawableResource("drawable:F38", setOf(
        ResourceItem(setOf(), "${MD}drawable/F38.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_481_048_196)
internal val Res.drawable.F38A: DrawableResource by lazy {
      DrawableResource("drawable:F38A", setOf(
        ResourceItem(setOf(), "${MD}drawable/F38A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_448_045_080)
internal val Res.drawable.F39: DrawableResource by lazy {
      DrawableResource("drawable:F39", setOf(
        ResourceItem(setOf(), "${MD}drawable/F39.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-381_359_239)
internal val Res.drawable.F4: DrawableResource by lazy {
      DrawableResource("drawable:F4", setOf(
        ResourceItem(setOf(), "${MD}drawable/F4.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_001_306_903)
internal val Res.drawable.F40: DrawableResource by lazy {
      DrawableResource("drawable:F40", setOf(
        ResourceItem(setOf(), "${MD}drawable/F40.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(69_989_226)
internal val Res.drawable.F41: DrawableResource by lazy {
      DrawableResource("drawable:F41", setOf(
        ResourceItem(setOf(), "${MD}drawable/F41.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_318_621_235)
internal val Res.drawable.F42: DrawableResource by lazy {
      DrawableResource("drawable:F42", setOf(
        ResourceItem(setOf(), "${MD}drawable/F42.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_539_767_340)
internal val Res.drawable.F43: DrawableResource by lazy {
      DrawableResource("drawable:F43", setOf(
        ResourceItem(setOf(), "${MD}drawable/F43.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_466_266_120)
internal val Res.drawable.F44: DrawableResource by lazy {
      DrawableResource("drawable:F44", setOf(
        ResourceItem(setOf(), "${MD}drawable/F44.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_859_301_447)
internal val Res.drawable.F45: DrawableResource by lazy {
      DrawableResource("drawable:F45", setOf(
        ResourceItem(setOf(), "${MD}drawable/F45.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-5_675_563)
internal val Res.drawable.F45A: DrawableResource by lazy {
      DrawableResource("drawable:F45A", setOf(
        ResourceItem(setOf(), "${MD}drawable/F45A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_144_734_377)
internal val Res.drawable.F46: DrawableResource by lazy {
      DrawableResource("drawable:F46", setOf(
        ResourceItem(setOf(), "${MD}drawable/F46.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(900_650_092)
internal val Res.drawable.F46A: DrawableResource by lazy {
      DrawableResource("drawable:F46A", setOf(
        ResourceItem(setOf(), "${MD}drawable/F46A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(601_821_332)
internal val Res.drawable.F47: DrawableResource by lazy {
      DrawableResource("drawable:F47", setOf(
        ResourceItem(setOf(), "${MD}drawable/F47.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-511_083_287)
internal val Res.drawable.F47A: DrawableResource by lazy {
      DrawableResource("drawable:F47A", setOf(
        ResourceItem(setOf(), "${MD}drawable/F47A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_270_273_460)
internal val Res.drawable.F48: DrawableResource by lazy {
      DrawableResource("drawable:F48", setOf(
        ResourceItem(setOf(), "${MD}drawable/F48.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_342_048_825)
internal val Res.drawable.F49: DrawableResource by lazy {
      DrawableResource("drawable:F49", setOf(
        ResourceItem(setOf(), "${MD}drawable/F49.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_041_224_578)
internal val Res.drawable.F5: DrawableResource by lazy {
      DrawableResource("drawable:F5", setOf(
        ResourceItem(setOf(), "${MD}drawable/F5.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_511_018_543)
internal val Res.drawable.F50: DrawableResource by lazy {
      DrawableResource("drawable:F50", setOf(
        ResourceItem(setOf(), "${MD}drawable/F50.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(269_983_184)
internal val Res.drawable.F51: DrawableResource by lazy {
      DrawableResource("drawable:F51", setOf(
        ResourceItem(setOf(), "${MD}drawable/F51.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_047_494_723)
internal val Res.drawable.F51A: DrawableResource by lazy {
      DrawableResource("drawable:F51A", setOf(
        ResourceItem(setOf(), "${MD}drawable/F51A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_397_653_214)
internal val Res.drawable.F51B: DrawableResource by lazy {
      DrawableResource("drawable:F51B", setOf(
        ResourceItem(setOf(), "${MD}drawable/F51B.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_879_434_565)
internal val Res.drawable.F51C: DrawableResource by lazy {
      DrawableResource("drawable:F51C", setOf(
        ResourceItem(setOf(), "${MD}drawable/F51C.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-186_129_856)
internal val Res.drawable.F52: DrawableResource by lazy {
      DrawableResource("drawable:F52", setOf(
        ResourceItem(setOf(), "${MD}drawable/F52.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(976_533_088)
internal val Res.drawable.F53: DrawableResource by lazy {
      DrawableResource("drawable:F53", setOf(
        ResourceItem(setOf(), "${MD}drawable/F53.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_038_772_689)
internal val Res.drawable.F6: DrawableResource by lazy {
      DrawableResource("drawable:F6", setOf(
        ResourceItem(setOf(), "${MD}drawable/F6.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_573_344_547)
internal val Res.drawable.F7: DrawableResource by lazy {
      DrawableResource("drawable:F7", setOf(
        ResourceItem(setOf(), "${MD}drawable/F7.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-117_557_310)
internal val Res.drawable.F8: DrawableResource by lazy {
      DrawableResource("drawable:F8", setOf(
        ResourceItem(setOf(), "${MD}drawable/F8.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(871_204_940)
internal val Res.drawable.F9: DrawableResource by lazy {
      DrawableResource("drawable:F9", setOf(
        ResourceItem(setOf(), "${MD}drawable/F9.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(135_807_129)
internal val Res.drawable.G1: DrawableResource by lazy {
      DrawableResource("drawable:G1", setOf(
        ResourceItem(setOf(), "${MD}drawable/G1.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_350_638_270)
internal val Res.drawable.G10: DrawableResource by lazy {
      DrawableResource("drawable:G10", setOf(
        ResourceItem(setOf(), "${MD}drawable/G10.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_080_753_628)
internal val Res.drawable.G11: DrawableResource by lazy {
      DrawableResource("drawable:G11", setOf(
        ResourceItem(setOf(), "${MD}drawable/G11.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(503_567_698)
internal val Res.drawable.G11A: DrawableResource by lazy {
      DrawableResource("drawable:G11A", setOf(
        ResourceItem(setOf(), "${MD}drawable/G11A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_554_886_638)
internal val Res.drawable.G12: DrawableResource by lazy {
      DrawableResource("drawable:G12", setOf(
        ResourceItem(setOf(), "${MD}drawable/G12.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(422_516_230)
internal val Res.drawable.G13: DrawableResource by lazy {
      DrawableResource("drawable:G13", setOf(
        ResourceItem(setOf(), "${MD}drawable/G13.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(107_767_041)
internal val Res.drawable.G14: DrawableResource by lazy {
      DrawableResource("drawable:G14", setOf(
        ResourceItem(setOf(), "${MD}drawable/G14.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(360_109_006)
internal val Res.drawable.G15: DrawableResource by lazy {
      DrawableResource("drawable:G15", setOf(
        ResourceItem(setOf(), "${MD}drawable/G15.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-369_261_008)
internal val Res.drawable.G16: DrawableResource by lazy {
      DrawableResource("drawable:G16", setOf(
        ResourceItem(setOf(), "${MD}drawable/G16.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-918_106_687)
internal val Res.drawable.G17: DrawableResource by lazy {
      DrawableResource("drawable:G17", setOf(
        ResourceItem(setOf(), "${MD}drawable/G17.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_286_450_090)
internal val Res.drawable.G18: DrawableResource by lazy {
      DrawableResource("drawable:G18", setOf(
        ResourceItem(setOf(), "${MD}drawable/G18.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-100_475_564)
internal val Res.drawable.G19: DrawableResource by lazy {
      DrawableResource("drawable:G19", setOf(
        ResourceItem(setOf(), "${MD}drawable/G19.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(274_618_896)
internal val Res.drawable.G2: DrawableResource by lazy {
      DrawableResource("drawable:G2", setOf(
        ResourceItem(setOf(), "${MD}drawable/G2.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_957_665_629)
internal val Res.drawable.G20: DrawableResource by lazy {
      DrawableResource("drawable:G20", setOf(
        ResourceItem(setOf(), "${MD}drawable/G20.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_389_433_079)
internal val Res.drawable.G20A: DrawableResource by lazy {
      DrawableResource("drawable:G20A", setOf(
        ResourceItem(setOf(), "${MD}drawable/G20A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-698_124_909)
internal val Res.drawable.G21: DrawableResource by lazy {
      DrawableResource("drawable:G21", setOf(
        ResourceItem(setOf(), "${MD}drawable/G21.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_026_315_045)
internal val Res.drawable.G22: DrawableResource by lazy {
      DrawableResource("drawable:G22", setOf(
        ResourceItem(setOf(), "${MD}drawable/G22.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(431_969_785)
internal val Res.drawable.G23: DrawableResource by lazy {
      DrawableResource("drawable:G23", setOf(
        ResourceItem(setOf(), "${MD}drawable/G23.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-819_254_986)
internal val Res.drawable.G24: DrawableResource by lazy {
      DrawableResource("drawable:G24", setOf(
        ResourceItem(setOf(), "${MD}drawable/G24.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(191_223_198)
internal val Res.drawable.G25: DrawableResource by lazy {
      DrawableResource("drawable:G25", setOf(
        ResourceItem(setOf(), "${MD}drawable/G25.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_508_326_067)
internal val Res.drawable.G26: DrawableResource by lazy {
      DrawableResource("drawable:G26", setOf(
        ResourceItem(setOf(), "${MD}drawable/G26.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_309_894_005)
internal val Res.drawable.G26A: DrawableResource by lazy {
      DrawableResource("drawable:G26A", setOf(
        ResourceItem(setOf(), "${MD}drawable/G26A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_136_041_417)
internal val Res.drawable.G27: DrawableResource by lazy {
      DrawableResource("drawable:G27", setOf(
        ResourceItem(setOf(), "${MD}drawable/G27.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_964_463_626)
internal val Res.drawable.G28: DrawableResource by lazy {
      DrawableResource("drawable:G28", setOf(
        ResourceItem(setOf(), "${MD}drawable/G28.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(515_788_050)
internal val Res.drawable.G29: DrawableResource by lazy {
      DrawableResource("drawable:G29", setOf(
        ResourceItem(setOf(), "${MD}drawable/G29.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-219_377_189)
internal val Res.drawable.G3: DrawableResource by lazy {
      DrawableResource("drawable:G3", setOf(
        ResourceItem(setOf(), "${MD}drawable/G3.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(491_504_694)
internal val Res.drawable.G30: DrawableResource by lazy {
      DrawableResource("drawable:G30", setOf(
        ResourceItem(setOf(), "${MD}drawable/G30.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_039_808_446)
internal val Res.drawable.G31: DrawableResource by lazy {
      DrawableResource("drawable:G31", setOf(
        ResourceItem(setOf(), "${MD}drawable/G31.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_025_400_609)
internal val Res.drawable.G32: DrawableResource by lazy {
      DrawableResource("drawable:G32", setOf(
        ResourceItem(setOf(), "${MD}drawable/G32.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-953_708_631)
internal val Res.drawable.G33: DrawableResource by lazy {
      DrawableResource("drawable:G33", setOf(
        ResourceItem(setOf(), "${MD}drawable/G33.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_421_135_395)
internal val Res.drawable.G34: DrawableResource by lazy {
      DrawableResource("drawable:G34", setOf(
        ResourceItem(setOf(), "${MD}drawable/G34.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(463_817_089)
internal val Res.drawable.G35: DrawableResource by lazy {
      DrawableResource("drawable:G35", setOf(
        ResourceItem(setOf(), "${MD}drawable/G35.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-394_476_729)
internal val Res.drawable.G36: DrawableResource by lazy {
      DrawableResource("drawable:G36", setOf(
        ResourceItem(setOf(), "${MD}drawable/G36.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_025_594_416)
internal val Res.drawable.G36A: DrawableResource by lazy {
      DrawableResource("drawable:G36A", setOf(
        ResourceItem(setOf(), "${MD}drawable/G36A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_552_884_134)
internal val Res.drawable.G37: DrawableResource by lazy {
      DrawableResource("drawable:G37", setOf(
        ResourceItem(setOf(), "${MD}drawable/G37.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_958_508_233)
internal val Res.drawable.G37A: DrawableResource by lazy {
      DrawableResource("drawable:G37A", setOf(
        ResourceItem(setOf(), "${MD}drawable/G37A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-551_232_856)
internal val Res.drawable.G38: DrawableResource by lazy {
      DrawableResource("drawable:G38", setOf(
        ResourceItem(setOf(), "${MD}drawable/G38.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-29_922_990)
internal val Res.drawable.G39: DrawableResource by lazy {
      DrawableResource("drawable:G39", setOf(
        ResourceItem(setOf(), "${MD}drawable/G39.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(32_587_873)
internal val Res.drawable.G39X1: DrawableResource by lazy {
      DrawableResource("drawable:G39X1", setOf(
        ResourceItem(setOf(), "${MD}drawable/G39X1.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(173_079_258)
internal val Res.drawable.G4: DrawableResource by lazy {
      DrawableResource("drawable:G4", setOf(
        ResourceItem(setOf(), "${MD}drawable/G4.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_510_662_932)
internal val Res.drawable.G40: DrawableResource by lazy {
      DrawableResource("drawable:G40", setOf(
        ResourceItem(setOf(), "${MD}drawable/G40.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(927_782_677)
internal val Res.drawable.G41: DrawableResource by lazy {
      DrawableResource("drawable:G41", setOf(
        ResourceItem(setOf(), "${MD}drawable/G41.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_133_588_862)
internal val Res.drawable.G42: DrawableResource by lazy {
      DrawableResource("drawable:G42", setOf(
        ResourceItem(setOf(), "${MD}drawable/G42.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(381_844_384)
internal val Res.drawable.G43: DrawableResource by lazy {
      DrawableResource("drawable:G43", setOf(
        ResourceItem(setOf(), "${MD}drawable/G43.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-890_366_650)
internal val Res.drawable.G43A: DrawableResource by lazy {
      DrawableResource("drawable:G43A", setOf(
        ResourceItem(setOf(), "${MD}drawable/G43A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_370_009_064)
internal val Res.drawable.G43B: DrawableResource by lazy {
      DrawableResource("drawable:G43B", setOf(
        ResourceItem(setOf(), "${MD}drawable/G43B.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_609_857_378)
internal val Res.drawable.G44: DrawableResource by lazy {
      DrawableResource("drawable:G44", setOf(
        ResourceItem(setOf(), "${MD}drawable/G44.webp", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable3Resources(map: MutableMap<String, DrawableResource>) {
  map.put("F1A", Res.drawable.F1A)
  map.put("F2", Res.drawable.F2)
  map.put("F20", Res.drawable.F20)
  map.put("F21", Res.drawable.F21)
  map.put("F21A", Res.drawable.F21A)
  map.put("F22", Res.drawable.F22)
  map.put("F23", Res.drawable.F23)
  map.put("F24", Res.drawable.F24)
  map.put("F25", Res.drawable.F25)
  map.put("F26", Res.drawable.F26)
  map.put("F27", Res.drawable.F27)
  map.put("F28", Res.drawable.F28)
  map.put("F29", Res.drawable.F29)
  map.put("F3", Res.drawable.F3)
  map.put("F30", Res.drawable.F30)
  map.put("F31", Res.drawable.F31)
  map.put("F31A", Res.drawable.F31A)
  map.put("F32", Res.drawable.F32)
  map.put("F33", Res.drawable.F33)
  map.put("F34", Res.drawable.F34)
  map.put("F35", Res.drawable.F35)
  map.put("F36", Res.drawable.F36)
  map.put("F37", Res.drawable.F37)
  map.put("F37A", Res.drawable.F37A)
  map.put("F38", Res.drawable.F38)
  map.put("F38A", Res.drawable.F38A)
  map.put("F39", Res.drawable.F39)
  map.put("F4", Res.drawable.F4)
  map.put("F40", Res.drawable.F40)
  map.put("F41", Res.drawable.F41)
  map.put("F42", Res.drawable.F42)
  map.put("F43", Res.drawable.F43)
  map.put("F44", Res.drawable.F44)
  map.put("F45", Res.drawable.F45)
  map.put("F45A", Res.drawable.F45A)
  map.put("F46", Res.drawable.F46)
  map.put("F46A", Res.drawable.F46A)
  map.put("F47", Res.drawable.F47)
  map.put("F47A", Res.drawable.F47A)
  map.put("F48", Res.drawable.F48)
  map.put("F49", Res.drawable.F49)
  map.put("F5", Res.drawable.F5)
  map.put("F50", Res.drawable.F50)
  map.put("F51", Res.drawable.F51)
  map.put("F51A", Res.drawable.F51A)
  map.put("F51B", Res.drawable.F51B)
  map.put("F51C", Res.drawable.F51C)
  map.put("F52", Res.drawable.F52)
  map.put("F53", Res.drawable.F53)
  map.put("F6", Res.drawable.F6)
  map.put("F7", Res.drawable.F7)
  map.put("F8", Res.drawable.F8)
  map.put("F9", Res.drawable.F9)
  map.put("G1", Res.drawable.G1)
  map.put("G10", Res.drawable.G10)
  map.put("G11", Res.drawable.G11)
  map.put("G11A", Res.drawable.G11A)
  map.put("G12", Res.drawable.G12)
  map.put("G13", Res.drawable.G13)
  map.put("G14", Res.drawable.G14)
  map.put("G15", Res.drawable.G15)
  map.put("G16", Res.drawable.G16)
  map.put("G17", Res.drawable.G17)
  map.put("G18", Res.drawable.G18)
  map.put("G19", Res.drawable.G19)
  map.put("G2", Res.drawable.G2)
  map.put("G20", Res.drawable.G20)
  map.put("G20A", Res.drawable.G20A)
  map.put("G21", Res.drawable.G21)
  map.put("G22", Res.drawable.G22)
  map.put("G23", Res.drawable.G23)
  map.put("G24", Res.drawable.G24)
  map.put("G25", Res.drawable.G25)
  map.put("G26", Res.drawable.G26)
  map.put("G26A", Res.drawable.G26A)
  map.put("G27", Res.drawable.G27)
  map.put("G28", Res.drawable.G28)
  map.put("G29", Res.drawable.G29)
  map.put("G3", Res.drawable.G3)
  map.put("G30", Res.drawable.G30)
  map.put("G31", Res.drawable.G31)
  map.put("G32", Res.drawable.G32)
  map.put("G33", Res.drawable.G33)
  map.put("G34", Res.drawable.G34)
  map.put("G35", Res.drawable.G35)
  map.put("G36", Res.drawable.G36)
  map.put("G36A", Res.drawable.G36A)
  map.put("G37", Res.drawable.G37)
  map.put("G37A", Res.drawable.G37A)
  map.put("G38", Res.drawable.G38)
  map.put("G39", Res.drawable.G39)
  map.put("G39X1", Res.drawable.G39X1)
  map.put("G4", Res.drawable.G4)
  map.put("G40", Res.drawable.G40)
  map.put("G41", Res.drawable.G41)
  map.put("G42", Res.drawable.G42)
  map.put("G43", Res.drawable.G43)
  map.put("G43A", Res.drawable.G43A)
  map.put("G43B", Res.drawable.G43B)
  map.put("G44", Res.drawable.G44)
}
